module.exports = __webpack_public_path__ + "img/Picto_Step_03.8795021b.png";